import { HandHelping, ChevronDown } from "lucide-react";
import { Clock, Heart } from "react-feather";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import React, { useRef } from "react"; // ✅ Correct single import
import { Link } from "react-router-dom";
import Header from "../components/header";
import Footer from '../components/footer';
import FloatingChatButton from '../components/FloatingChatButton';
import { useEffect, useState } from "react";
import { fundraiserService } from "../services/api";

// Comprehensive list of countries with their codes
const countries = [
  { code: '+93', name: 'Afghanistan', flag: '🇦🇫' },
  { code: '+355', name: 'Albania', flag: '🇦🇱' },
  { code: '+213', name: 'Algeria', flag: '🇩🇿' },
  { code: '+1', name: 'United States', flag: '🇺🇸' },
  { code: '+376', name: 'Andorra', flag: '🇦🇩' },
  { code: '+244', name: 'Angola', flag: '🇦🇴' },
  { code: '+54', name: 'Argentina', flag: '🇦🇷' },
  { code: '+374', name: 'Armenia', flag: '🇦🇲' },
  { code: '+61', name: 'Australia', flag: '🇦🇺' },
  { code: '+43', name: 'Austria', flag: '🇦🇹' },
  { code: '+994', name: 'Azerbaijan', flag: '🇦🇿' },
  { code: '+973', name: 'Bahrain', flag: '🇧🇭' },
  { code: '+880', name: 'Bangladesh', flag: '🇧🇩' },
  { code: '+375', name: 'Belarus', flag: '🇧🇾' },
  { code: '+32', name: 'Belgium', flag: '🇧🇪' },
  { code: '+501', name: 'Belize', flag: '🇧🇿' },
  { code: '+229', name: 'Benin', flag: '🇧🇯' },
  { code: '+975', name: 'Bhutan', flag: '🇧🇹' },
  { code: '+591', name: 'Bolivia', flag: '🇧🇴' },
  { code: '+387', name: 'Bosnia and Herzegovina', flag: '🇧🇦' },
  { code: '+267', name: 'Botswana', flag: '🇧🇼' },
  { code: '+55', name: 'Brazil', flag: '🇧🇷' },
  { code: '+673', name: 'Brunei', flag: '🇧🇳' },
  { code: '+359', name: 'Bulgaria', flag: '🇧🇬' },
  { code: '+226', name: 'Burkina Faso', flag: '🇧🇫' },
  { code: '+257', name: 'Burundi', flag: '🇧🇮' },
  { code: '+855', name: 'Cambodia', flag: '🇰🇭' },
  { code: '+237', name: 'Cameroon', flag: '🇨🇲' },
  { code: '+1', name: 'Canada', flag: '🇨🇦' },
  { code: '+238', name: 'Cape Verde', flag: '🇨🇻' },
  { code: '+236', name: 'Central African Republic', flag: '🇨🇫' },
  { code: '+235', name: 'Chad', flag: '🇹🇩' },
  { code: '+56', name: 'Chile', flag: '🇨🇱' },
  { code: '+86', name: 'China', flag: '🇨🇳' },
  { code: '+57', name: 'Colombia', flag: '🇨🇴' },
  { code: '+269', name: 'Comoros', flag: '🇰🇲' },
  { code: '+242', name: 'Congo', flag: '🇨🇬' },
  { code: '+243', name: 'Congo (DRC)', flag: '🇨🇩' },
  { code: '+506', name: 'Costa Rica', flag: '🇨🇷' },
  { code: '+385', name: 'Croatia', flag: '🇭🇷' },
  { code: '+53', name: 'Cuba', flag: '🇨🇺' },
  { code: '+357', name: 'Cyprus', flag: '🇨🇾' },
  { code: '+420', name: 'Czech Republic', flag: '🇨🇿' },
  { code: '+45', name: 'Denmark', flag: '🇩🇰' },
  { code: '+253', name: 'Djibouti', flag: '🇩🇯' },
  { code: '+1', name: 'Dominican Republic', flag: '🇩🇴' },
  { code: '+593', name: 'Ecuador', flag: '🇪🇨' },
  { code: '+20', name: 'Egypt', flag: '🇪🇬' },
  { code: '+503', name: 'El Salvador', flag: '🇸🇻' },
  { code: '+240', name: 'Equatorial Guinea', flag: '🇬🇶' },
  { code: '+291', name: 'Eritrea', flag: '🇪🇷' },
  { code: '+372', name: 'Estonia', flag: '🇪🇪' },
  { code: '+251', name: 'Ethiopia', flag: '🇪🇹' },
  { code: '+679', name: 'Fiji', flag: '🇫🇯' },
  { code: '+358', name: 'Finland', flag: '🇫🇮' },
  { code: '+33', name: 'France', flag: '🇫🇷' },
  { code: '+241', name: 'Gabon', flag: '🇬🇦' },
  { code: '+220', name: 'Gambia', flag: '🇬🇲' },
  { code: '+995', name: 'Georgia', flag: '🇬🇪' },
  { code: '+49', name: 'Germany', flag: '🇩🇪' },
  { code: '+233', name: 'Ghana', flag: '🇬🇭' },
  { code: '+30', name: 'Greece', flag: '🇬🇷' },
  { code: '+502', name: 'Guatemala', flag: '🇬🇹' },
  { code: '+224', name: 'Guinea', flag: '🇬🇳' },
  { code: '+245', name: 'Guinea-Bissau', flag: '🇬🇼' },
  { code: '+592', name: 'Guyana', flag: '🇬🇾' },
  { code: '+509', name: 'Haiti', flag: '🇭🇹' },
  { code: '+504', name: 'Honduras', flag: '🇭🇳' },
  { code: '+852', name: 'Hong Kong', flag: '🇭🇰' },
  { code: '+36', name: 'Hungary', flag: '🇭🇺' },
  { code: '+354', name: 'Iceland', flag: '🇮🇸' },
  { code: '+91', name: 'India', flag: '🇮🇳' },
  { code: '+62', name: 'Indonesia', flag: '🇮🇩' },
  { code: '+98', name: 'Iran', flag: '🇮🇷' },
  { code: '+964', name: 'Iraq', flag: '🇮🇶' },
  { code: '+353', name: 'Ireland', flag: '🇮🇪' },
  { code: '+972', name: 'Israel', flag: '🇮🇱' },
  { code: '+39', name: 'Italy', flag: '🇮🇹' },
  { code: '+225', name: 'Ivory Coast', flag: '🇨🇮' },
  { code: '+81', name: 'Japan', flag: '🇯🇵' },
  { code: '+962', name: 'Jordan', flag: '🇯🇴' },
  { code: '+7', name: 'Kazakhstan', flag: '🇰🇿' },
  { code: '+254', name: 'Kenya', flag: '🇰🇪' },
  { code: '+686', name: 'Kiribati', flag: '🇰🇮' },
  { code: '+965', name: 'Kuwait', flag: '🇰🇼' },
  { code: '+996', name: 'Kyrgyzstan', flag: '🇰🇬' },
  { code: '+856', name: 'Laos', flag: '🇱🇦' },
  { code: '+371', name: 'Latvia', flag: '🇱🇻' },
  { code: '+961', name: 'Lebanon', flag: '🇱🇧' },
  { code: '+266', name: 'Lesotho', flag: '🇱🇸' },
  { code: '+231', name: 'Liberia', flag: '🇱🇷' },
  { code: '+218', name: 'Libya', flag: '🇱🇾' },
  { code: '+423', name: 'Liechtenstein', flag: '🇱🇮' },
  { code: '+370', name: 'Lithuania', flag: '🇱🇹' },
  { code: '+352', name: 'Luxembourg', flag: '🇱🇺' },
  { code: '+853', name: 'Macau', flag: '🇲🇴' },
  { code: '+389', name: 'Macedonia', flag: '🇲🇰' },
  { code: '+261', name: 'Madagascar', flag: '🇲🇬' },
  { code: '+265', name: 'Malawi', flag: '🇲🇼' },
  { code: '+60', name: 'Malaysia', flag: '🇲🇾' },
  { code: '+960', name: 'Maldives', flag: '🇲🇻' },
  { code: '+223', name: 'Mali', flag: '🇲🇱' },
  { code: '+356', name: 'Malta', flag: '🇲🇹' },
  { code: '+692', name: 'Marshall Islands', flag: '🇲🇭' },
  { code: '+222', name: 'Mauritania', flag: '🇲🇷' },
  { code: '+230', name: 'Mauritius', flag: '🇲🇺' },
  { code: '+52', name: 'Mexico', flag: '🇲🇽' },
  { code: '+691', name: 'Micronesia', flag: '🇫🇲' },
  { code: '+373', name: 'Moldova', flag: '🇲🇩' },
  { code: '+377', name: 'Monaco', flag: '🇲🇨' },
  { code: '+976', name: 'Mongolia', flag: '🇲🇳' },
  { code: '+382', name: 'Montenegro', flag: '🇲🇪' },
  { code: '+212', name: 'Morocco', flag: '🇲🇦' },
  { code: '+258', name: 'Mozambique', flag: '🇲🇿' },
  { code: '+95', name: 'Myanmar', flag: '🇲🇲' },
  { code: '+264', name: 'Namibia', flag: '🇳🇦' },
  { code: '+674', name: 'Nauru', flag: '🇳🇷' },
  { code: '+977', name: 'Nepal', flag: '🇳🇵' },
  { code: '+31', name: 'Netherlands', flag: '🇳🇱' },
  { code: '+64', name: 'New Zealand', flag: '🇳🇿' },
  { code: '+505', name: 'Nicaragua', flag: '🇳🇮' },
  { code: '+227', name: 'Niger', flag: '🇳🇪' },
  { code: '+234', name: 'Nigeria', flag: '🇳🇬' },
  { code: '+850', name: 'North Korea', flag: '🇰🇵' },
  { code: '+47', name: 'Norway', flag: '🇳🇴' },
  { code: '+968', name: 'Oman', flag: '🇴🇲' },
  { code: '+92', name: 'Pakistan', flag: '🇵🇰' },
  { code: '+680', name: 'Palau', flag: '🇵🇼' },
  { code: '+970', name: 'Palestine', flag: '🇵🇸' },
  { code: '+507', name: 'Panama', flag: '🇵🇦' },
  { code: '+675', name: 'Papua New Guinea', flag: '🇵🇬' },
  { code: '+595', name: 'Paraguay', flag: '🇵🇾' },
  { code: '+51', name: 'Peru', flag: '🇵🇪' },
  { code: '+63', name: 'Philippines', flag: '🇵🇭' },
  { code: '+48', name: 'Poland', flag: '🇵🇱' },
  { code: '+351', name: 'Portugal', flag: '🇵🇹' },
  { code: '+974', name: 'Qatar', flag: '🇶🇦' },
  { code: '+40', name: 'Romania', flag: '🇷🇴' },
  { code: '+7', name: 'Russia', flag: '🇷🇺' },
  { code: '+250', name: 'Rwanda', flag: '🇷🇼' },
  { code: '+685', name: 'Samoa', flag: '🇼🇸' },
  { code: '+378', name: 'San Marino', flag: '🇸🇲' },
  { code: '+239', name: 'Sao Tome and Principe', flag: '🇸🇹' },
  { code: '+966', name: 'Saudi Arabia', flag: '🇸🇦' },
  { code: '+221', name: 'Senegal', flag: '🇸🇳' },
  { code: '+381', name: 'Serbia', flag: '🇷🇸' },
  { code: '+248', name: 'Seychelles', flag: '🇸🇨' },
  { code: '+232', name: 'Sierra Leone', flag: '🇸🇱' },
  { code: '+65', name: 'Singapore', flag: '🇸🇬' },
  { code: '+421', name: 'Slovakia', flag: '🇸🇰' },
  { code: '+386', name: 'Slovenia', flag: '🇸🇮' },
  { code: '+677', name: 'Solomon Islands', flag: '🇸🇧' },
  { code: '+252', name: 'Somalia', flag: '🇸🇴' },
  { code: '+27', name: 'South Africa', flag: '🇿🇦' },
  { code: '+82', name: 'South Korea', flag: '🇰🇷' },
  { code: '+211', name: 'South Sudan', flag: '🇸🇸' },
  { code: '+34', name: 'Spain', flag: '🇪🇸' },
  { code: '+94', name: 'Sri Lanka', flag: '🇱🇰' },
  { code: '+249', name: 'Sudan', flag: '🇸🇩' },
  { code: '+597', name: 'Suriname', flag: '🇸🇷' },
  { code: '+268', name: 'Swaziland', flag: '🇸🇿' },
  { code: '+46', name: 'Sweden', flag: '🇸🇪' },
  { code: '+41', name: 'Switzerland', flag: '🇨🇭' },
  { code: '+963', name: 'Syria', flag: '🇸🇾' },
  { code: '+886', name: 'Taiwan', flag: '🇹🇼' },
  { code: '+992', name: 'Tajikistan', flag: '🇹🇯' },
  { code: '+255', name: 'Tanzania', flag: '🇹🇿' },
  { code: '+66', name: 'Thailand', flag: '🇹🇭' },
  { code: '+670', name: 'Timor-Leste', flag: '🇹🇱' },
  { code: '+228', name: 'Togo', flag: '🇹🇬' },
  { code: '+676', name: 'Tonga', flag: '🇹🇴' },
  { code: '+1', name: 'Trinidad and Tobago', flag: '🇹🇹' },
  { code: '+216', name: 'Tunisia', flag: '🇹🇳' },
  { code: '+90', name: 'Turkey', flag: '🇹🇷' },
  { code: '+993', name: 'Turkmenistan', flag: '🇹🇲' },
  { code: '+688', name: 'Tuvalu', flag: '🇹🇻' },
  { code: '+256', name: 'Uganda', flag: '🇺🇬' },
  { code: '+380', name: 'Ukraine', flag: '🇺🇦' },
  { code: '+971', name: 'UAE', flag: '🇦🇪' },
  { code: '+44', name: 'United Kingdom', flag: '🇬🇧' },
  { code: '+598', name: 'Uruguay', flag: '🇺🇾' },
  { code: '+998', name: 'Uzbekistan', flag: '🇺🇿' },
  { code: '+678', name: 'Vanuatu', flag: '🇻🇺' },
  { code: '+39', name: 'Vatican City', flag: '🇻🇦' },
  { code: '+58', name: 'Venezuela', flag: '🇻🇪' },
  { code: '+84', name: 'Vietnam', flag: '🇻🇳' },
  { code: '+967', name: 'Yemen', flag: '🇾🇪' },
  { code: '+260', name: 'Zambia', flag: '🇿🇲' },
  { code: '+263', name: 'Zimbabwe', flag: '🇿🇼' }
];

const testimonials = [
  {
    name: "Mr. Rahul Kumar, Librarian, XYZ University",
    raised: "Rs. 10,90,850/-",
    image: "https://randomuser.me/api/portraits/men/45.jpg",
    stars: 5,
    quote:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua...",
  },
  {
    name: "Ms. Aarti Sharma, Professor, ABC College",
    raised: "Rs. 7,25,000/-",
    image: "https://randomuser.me/api/portraits/women/68.jpg",
    stars: 4,
    quote:
      "Medical Linkers gave us hope when all seemed lost. The support and donations helped us more than we could imagine.",
  },
];

const faqs = [
  {
    question: "I want to start a medical fundraiser. What all do I need?",
    answer:
      "For your fundraiser to be as transparent as possible, upload a scanned copy of your hospital bill mentioning the medical condition and the amount you require along with a high-resolution photograph of the patient.",
  },
  {
    question:
      "I don’t see the medical treatment I want to raise funds for in the list, what do I do?",
    answer: "",
  },
  {
    question:
      "I want to start raising funds, how do I start a fundraiser on Ketto?",
    answer: "",
  },
  {
    question: "I have more questions, who do I write to?",
    answer: "",
  },
];

const DonationPage = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [openIndex, setOpenIndex] = useState(0); // First FAQ is open by default
  const [fundraisers, setFundraisers] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Form states for both forms
  const [monthlyDonorForm, setMonthlyDonorForm] = useState({
    name: '',
    email: '',
    countryCode: '+91', // Default to India
    mobile: '',
    fundsFor: ''
  });

  const [fundraiserForm, setFundraiserForm] = useState({
    name: '',
    email: '',
    countryCode: '+91', // Default to India
    mobile: '',
    fundsFor: '',
    story: ''
  });

  const handleMonthlyDonorChange = (e) => {
    const { name, value } = e.target;
    setMonthlyDonorForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFundraiserChange = (e) => {
    const { name, value } = e.target;
    setFundraiserForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleMonthlyDonorSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('https://medical-linkers.onrender.com/api/contacts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...monthlyDonorForm,
          formType: 'monthly-donor'
        }),
      });

      const data = await response.json();

      if (data.success) {
        alert('Thank you! Your monthly donor registration has been submitted successfully.');
        setMonthlyDonorForm({
          name: '',
          email: '',
          countryCode: '+91',
          mobile: '',
          fundsFor: ''
        });
      } else {
        alert(data.message || 'Failed to submit form. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting monthly donor form:', error);
      alert('Failed to submit form. Please try again.');
    }
  };

  const handleFundraiserSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('https://medical-linkers.onrender.com/api/contacts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...fundraiserForm,
          formType: 'fundraiser'
        }),
      });

      const data = await response.json();

      if (data.success) {
        alert('Thank you! Your fundraiser request has been submitted successfully.');
        setFundraiserForm({
          name: '',
          email: '',
          countryCode: '+91',
          mobile: '',
          fundsFor: '',
          story: ''
        });
      } else {
        alert(data.message || 'Failed to submit form. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting fundraiser form:', error);
      alert('Failed to submit form. Please try again.');
    }
  };

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const fetchFundraisers = async () => {
    try {
      setLoading(true);
      const response = await fundraiserService.getActive({ limit: 4 });
      setFundraisers(response.data.fundraisers || []);
    } catch (error) {
      console.error('Error fetching fundraisers:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDonate = (fundraiser) => {
    const message = `Hi, I would like to donate to the fundraiser: "${fundraiser.title}" for ${fundraiser.patientName}. Please provide me with the donation details.`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappNumber = fundraiser.whatsappNumber.replace(/\D/g, ''); // Remove non-digits
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  useEffect(() => {
    fetchFundraisers();
  }, []);

  useEffect(() => {
    // Ensure refs are defined
    // No initialization needed
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <section className="relative font-sans text-white overflow-hidden">
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center z-0"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1593113598332-cd288d649433?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3')",
          }}
        >
          <div className="absolute inset-0 bg-blue-800/60"></div>
        </div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-16 items-center min-h-[calc(100vh-140px)] py-16 lg:py-0">
            <div className="flex flex-col items-start text-left">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight">
                Donate for Care
              </h1>
              <p className="mt-4 text-xl md:text-2xl max-w-lg">
                Your Contribution can save a life today
              </p>
              <button className="mt-8 bg-blue-600 text-white font-bold py-3 px-8 rounded-lg hover:bg-blue-700 transition-colors text-lg">
                See all Active Fundraisers
              </button>
            </div>

            <div className="flex items-center justify-center lg:justify-end">
              <section className="w-full bg-white p-4 sm:p-6 rounded-2xl shadow-2xl max-w-md font-sans my-6">
                <div className="flex justify-center mb-4">
                  <div className="bg-blue-100 p-3 rounded-full">
                    <HandHelping className="text-blue-600" size={32} />
                  </div>
                </div>
                <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
                  Become a Monthly Donor
                </h2>
                <form onSubmit={handleMonthlyDonorSubmit} className="space-y-4">
                  <div>
                    <label
                      htmlFor="monthly-name"
                      className="text-sm font-medium text-gray-600"
                    >
                      Name *
                    </label>
                    <input
                      type="text"
                      id="monthly-name"
                      name="name"
                      value={monthlyDonorForm.name}
                      onChange={handleMonthlyDonorChange}
                      required
                      className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none py-2 transition-colors text-gray-800"
                      style={{ color: '#374151' }}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="monthly-email"
                      className="text-sm font-medium text-gray-600"
                    >
                      Email *
                    </label>
                    <input
                      type="email"
                      id="monthly-email"
                      name="email"
                      value={monthlyDonorForm.email}
                      onChange={handleMonthlyDonorChange}
                      required
                      className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none py-2 transition-colors text-gray-800"
                      style={{ color: '#374151' }}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="monthly-country"
                      className="text-sm font-medium text-gray-600"
                    >
                      Country *
                    </label>
                    <select 
                      id="monthly-country"
                      name="countryCode"
                      value={monthlyDonorForm.countryCode}
                      onChange={handleMonthlyDonorChange}
                      required
                      className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none py-2 transition-colors appearance-none bg-transparent text-gray-800"
                      style={{ color: '#374151' }}
                    >
                      {countries.map((country) => (
                        <option 
                          key={country.code + country.name} 
                          value={country.code}
                          className="text-gray-800 bg-white"
                          style={{ color: '#374151', backgroundColor: '#ffffff' }}
                        >
                          {country.flag} {country.name} ({country.code})
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label
                      htmlFor="monthly-mobile"
                      className="text-sm font-medium text-gray-600"
                    >
                      Mobile Number *
                    </label>
                    <input
                      type="tel"
                      id="monthly-mobile"
                      name="mobile"
                      value={monthlyDonorForm.mobile}
                      onChange={handleMonthlyDonorChange}
                      required
                      placeholder="Mobile Number"
                      className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none py-2 transition-colors text-gray-800"
                      style={{ color: '#374151' }}
                    />
                  </div>
                  <div className="relative">
                    <label
                      htmlFor="monthly-funds-for"
                      className="text-sm font-medium text-gray-600"
                    >
                      Raise/Donate Funds for *
                    </label>
                    <select
                      id="monthly-funds-for"
                      name="fundsFor"
                      value={monthlyDonorForm.fundsFor}
                      onChange={handleMonthlyDonorChange}
                      required
                      className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none py-2 appearance-none bg-transparent pr-8 text-gray-800"
                      style={{ color: '#374151' }}
                    >
                      <option value="" className="text-gray-800 bg-white" style={{ color: '#374151', backgroundColor: '#ffffff' }}>Select an option</option>
                      <option value="medical" className="text-gray-800 bg-white" style={{ color: '#374151', backgroundColor: '#ffffff' }}>Medical Treatment</option>
                      <option value="education" className="text-gray-800 bg-white" style={{ color: '#374151', backgroundColor: '#ffffff' }}>Education</option>
                      <option value="disaster" className="text-gray-800 bg-white" style={{ color: '#374151', backgroundColor: '#ffffff' }}>Disaster Relief</option>
                    </select>
                    <ChevronDown className="absolute right-0 top-9 h-5 w-5 text-gray-400 pointer-events-none" />
                  </div>
                  <div>
                    <label
                      htmlFor="story"
                      className="text-sm font-medium text-gray-600"
                    >
                      Your Story
                    </label>
                    <textarea
                      id="story"
                      name="story"
                      rows="2"
                      className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none py-2 transition-colors"
                    ></textarea>
                  </div>
                  <div>
                    <button
                      type="submit"
                      className="w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-full hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 ease-in-out mt-4"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </section>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-50 py-12 px-4 sm:px-8 lg:px-16">
        {/* Heading & Main Description */}
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-800">
            Medical Fundraising & Crowdfunding
          </h2>
          <div className="w-16 h-1 bg-blue-600 mx-auto mt-2 mb-4 rounded-full" />
          <p className="text-gray-600 text-base sm:text-lg leading-relaxed">
            Online Medical crowdfunding is an alternative method for individuals
            and organisations to generate funds required for costly medical
            treatments like open-heart surgeries, NICU care, bone marrow
            transplant, cancer treatments and any other disease.
          </p>
        </div>

        {/* Text and Image Section */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          {/* Text Block */}
          <div>
            <h3 className="text-2xl font-semibold text-gray-800 mb-4">
              Medical Bills are a Burden for Many Individuals and Families
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Expenses related to hospital stays, cancer treatments with
              high-cost chemotherapy routines, and other medicinal costs can be
              even higher. Treatment costs and necessary living expenses can
              bring the best of families to the brink of experiencing hard
              times. Insurance plans are not enough, as policies do not cover
              everything you need.
            </p>
          </div>

          {/* Image Block */}
          <div className="flex justify-center">
            <img
              src="/images/hospitalbeds.jpg"
              alt="Hospital Beds"
              className="rounded-lg shadow-md w-full max-w-md"
            />
          </div>
        </div>
      </section>
      <section className="bg-gray-50 py-16 px-4 sm:px-8 lg:px-20 space-y-20">
        {/* Block 1 - Try Medical Crowdfunding */}
        <div className="grid md:grid-cols-2 gap-10 items-center">
          {/* Image */}
          <div className="flex justify-center md:justify-start">
            <img
              src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Holding paper heart"
              className="rounded-lg w-full max-w-sm"
            />
          </div>
          {/* Text */}
          <div>
            <h3 className="text-2xl font-semibold text-gray-800 mb-4">
              Try Medical Crowdfunding
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Stop worrying about rising medical bills, or debts and start a
              medical fundraising campaign. Ketto is a Crowdfunding Platform
              based out of India. Crowdfunding is the easiest way to avail
              support from friends, family and numerous individuals who are
              waiting to contribute funds.
            </p>
          </div>
        </div>

        {/* Block 2 - Start a Fundraiser */}
        <div className="grid md:grid-cols-2 gap-10 items-center">
          {/* Text */}
          <div>
            <h3 className="text-2xl font-semibold text-gray-800 mb-4">
              Start a Medical Fundraiser for Yourself or a Loved One
            </h3>
            <p className="text-gray-600 leading-relaxed">
              With Ketto, you can start a free, easy fundraiser in minutes to
              cover medical bills and healthcare costs. You can also take on the
              role of spreading the word and bring in funds when a close friend
              is diagnosed with unexpected illnesses. Medical fundraising
              campaigns can give your well-wishers a way to express support when
              needed.
            </p>
          </div>
          {/* Image */}
          <div className="flex justify-center md:justify-end">
            <img
              src="https://ideogram.ai/assets/image/lossless/response/e2GTig4-TEa09PpHnvfwRQ"
              alt="Phone with charts"
              className="rounded-lg w-full max-w-sm"
            />
          </div>
        </div>
      </section>
      <section className="bg-gray-50 py-16 px-4 sm:px-8 lg:px-16">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-10">
          Donate to Fundraisers
        </h2>

        {loading ? (
          <div className="text-center py-8">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading fundraisers...</p>
          </div>
        ) : fundraisers.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-600">No active fundraisers available at the moment.</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
              {fundraisers.map((f) => (
                <div
                  key={f._id}
                  className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col justify-between cursor-pointer hover:shadow-lg transition-shadow"
                  onClick={() => window.open(`/fundraiser/${f._id}`, '_blank')}
                >
                  <img
                    src={f.mainImage}
                    alt="Fundraiser banner"
                    className="w-full h-40 object-cover"
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/600x300?text=Fundraiser+Banner';
                    }}
                  />

                  <div className="p-4">
                    <h3 className="text-sm font-semibold text-gray-800 leading-tight mb-2 line-clamp-2">
                      {f.title}
                    </h3>

                    <p className="text-xs text-gray-600 mb-2">
                      by <span className="font-semibold">{f.patientName}</span>
                    </p>

                    <p className="text-sm font-bold text-gray-800 mb-1">
                      {f.formattedRaisedAmount}{" "}
                      <span className="font-normal text-gray-500">
                        raised out of {f.formattedGoalAmount}
                      </span>
                    </p>

                    <div className="w-full h-2 bg-blue-100 rounded-full my-2">
                      <div 
                        className="h-full bg-blue-400 rounded-full" 
                        style={{ width: `${Math.min(f.progressPercentage || 0, 100)}%` }}
                      ></div>
                    </div>

                    <p className="text-xs text-gray-500">{f.lastContributionFormatted}</p>

                    <div className="flex justify-between text-xs text-gray-500 mt-4">
                      <span className="flex items-center gap-1">
                        <Clock size={14} /> {f.daysLeft ? `${f.daysLeft} Days Left` : 'No deadline'}
                      </span>
                      <span className="flex items-center gap-1">
                        <Heart size={14} className="text-red-500" /> {f.supporters}{" "}
                        Supporters
                      </span>
                    </div>
                  </div>

                  <div className="p-4 pt-2">
                    <button 
                      className="w-full bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDonate(f);
                      }}
                    >
                      Donate Now
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 text-center">
              <Link
                to="/all-fundraisers"
                className="text-blue-600 font-semibold hover:underline text-sm"
              >
                See all active fundraisers
              </Link>
            </div>
          </>
        )}
      </section>

      {/* slider for fundraisers */}
      <section className="bg-blue-600 text-white py-16 px-6 relative">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-2">
            Hear from the Lives Impacted
          </h2>
          <div className="w-16 h-1 bg-white mx-auto mb-8 rounded-full"></div>

          <Swiper
            modules={[Navigation]}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            onBeforeInit={(swiper) => {
              if (prevRef.current && nextRef.current) {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
              }
            }}
            className="relative"
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="bg-blue-500 p-6 rounded-xl shadow-lg text-left mx-6">
                  <p className="text-lg italic mb-6">{`“${item.quote}”`}</p>
                  <div className="flex items-center gap-4">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-14 h-14 rounded-full object-cover"
                    />
                    <div>
                      <p className="font-bold">{item.name}</p>
                      <p>Raised {item.raised}</p>
                    </div>
                    <div className="ml-auto text-yellow-400 text-lg">
                      {"★".repeat(item.stars)}
                      {"☆".repeat(5 - item.stars)}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}

            {/* Custom Arrows */}
            <button
              ref={prevRef}
              className="absolute left-[-3rem] top-1/2 transform -translate-y-1/2 p-2 bg-white/30 hover:bg-white/40 text-white rounded-full z-10"
            >
              <ChevronDown className="rotate-90 w-6 h-6" />
            </button>
            <button
              ref={nextRef}
              className="absolute right-[-3rem] top-1/2 transform -translate-y-1/2 p-2 bg-white/30 hover:bg-white/40 text-white rounded-full z-10"
            >
              <ChevronDown className="-rotate-90 w-6 h-6" />
            </button>
          </Swiper>
        </div>
      </section>

      <section className="bg-gray-50 py-16 px-4 sm:px-8 lg:px-20">
        <div className="max-w-6xl mx-auto text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-blue-600 mb-2">
            Start a Fundraiser Today
          </h2>
          <p className="text-gray-700 text-lg sm:text-xl">
            Make an impact today, you can save a life
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Left: Form */}
          <section className="w-full bg-white p-6 rounded-2xl shadow-xl max-w-md mx-auto md:mx-0">
            <form onSubmit={handleFundraiserSubmit} className="space-y-5">
              <div>
                <label
                  htmlFor="fundraiser-name"
                  className="block text-sm font-medium text-gray-600"
                >
                  Name *
                </label>
                <input
                  type="text"
                  id="fundraiser-name"
                  name="name"
                  value={fundraiserForm.name}
                  onChange={handleFundraiserChange}
                  required
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none py-2 text-gray-800"
                  style={{ color: '#374151' }}
                />
              </div>
              <div>
                <label
                  htmlFor="fundraiser-email"
                  className="block text-sm font-medium text-gray-600"
                >
                  Email *
                </label>
                <input
                  type="email"
                  id="fundraiser-email"
                  name="email"
                  value={fundraiserForm.email}
                  onChange={handleFundraiserChange}
                  required
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none py-2 text-gray-800"
                  style={{ color: '#374151' }}
                />
              </div>
              <div>
                <label
                  htmlFor="fundraiser-country"
                  className="block text-sm font-medium text-gray-600"
                >
                  Country *
                </label>
                <select 
                  id="fundraiser-country"
                  name="countryCode"
                  value={fundraiserForm.countryCode}
                  onChange={handleFundraiserChange}
                  required
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none py-2 appearance-none bg-transparent text-gray-800"
                  style={{ color: '#374151' }}
                >
                  {countries.map((country) => (
                    <option 
                      key={country.code + country.name + '-fundraiser'} 
                      value={country.code}
                      className="text-gray-800 bg-white"
                      style={{ color: '#374151', backgroundColor: '#ffffff' }}
                    >
                      {country.flag} {country.name} ({country.code})
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label
                  htmlFor="fundraiser-mobile"
                  className="block text-sm font-medium text-gray-600"
                >
                  Mobile Number *
                </label>
                <input
                  type="tel"
                  id="fundraiser-mobile"
                  name="mobile"
                  value={fundraiserForm.mobile}
                  onChange={handleFundraiserChange}
                  required
                  placeholder="Mobile Number"
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none py-2 text-gray-800"
                  style={{ color: '#374151' }}
                />
              </div>
              <div className="relative">
                <label
                  htmlFor="fundraiser-funds-for"
                  className="block text-sm font-medium text-gray-600"
                >
                  Raise Funds for *
                </label>
                <select
                  id="fundraiser-funds-for"
                  name="fundsFor"
                  value={fundraiserForm.fundsFor}
                  onChange={handleFundraiserChange}
                  required
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none py-2 appearance-none pr-8 bg-transparent text-gray-800"
                  style={{ color: '#374151' }}
                >
                  <option value="" className="text-gray-800 bg-white" style={{ color: '#374151', backgroundColor: '#ffffff' }}>Select an option</option>
                  <option value="medical" className="text-gray-800 bg-white" style={{ color: '#374151', backgroundColor: '#ffffff' }}>Medical Treatment</option>
                  <option value="education" className="text-gray-800 bg-white" style={{ color: '#374151', backgroundColor: '#ffffff' }}>Education</option>
                  <option value="disaster" className="text-gray-800 bg-white" style={{ color: '#374151', backgroundColor: '#ffffff' }}>Disaster Relief</option>
                </select>
                <ChevronDown className="absolute right-0 top-9 h-5 w-5 text-gray-400 pointer-events-none" />
              </div>
              <div>
                <label
                  htmlFor="fundraiser-story"
                  className="block text-sm font-medium text-gray-600"
                >
                  Your Story
                </label>
                <textarea
                  id="fundraiser-story"
                  name="story"
                  value={fundraiserForm.story}
                  onChange={handleFundraiserChange}
                  rows="2"
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none py-2 text-gray-800"
                  style={{ color: '#374151' }}
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-full hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-300"
              >
                Submit
              </button>
            </form>
          </section>

          {/* Right: Image */}
          <div className="flex justify-center">
            <img
              src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Heart in hand"
              className="rounded-lg w-full max-w-md shadow-md"
            />
          </div>
        </div>
      </section>

      <section className="bg-gray-50 py-16 px-4 sm:px-8 lg:px-20">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-800">
            Frequently Asked Questions
          </h2>
          <div className="w-16 h-1 bg-blue-600 mx-auto mt-2 rounded-full" />
        </div>

        <div className="max-w-2xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`rounded-lg shadow-sm ${
                openIndex === index ? "bg-white" : "bg-gray-100"
              } transition`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full text-left p-4 font-medium text-gray-800 flex justify-between items-center"
              >
                <span>{faq.question}</span>
                <span className="text-xl text-gray-500">
                  {openIndex === index ? "▲" : "▼"}
                </span>
              </button>
              {openIndex === index && (
                <div className="px-4 pb-4 text-gray-600 text-sm">
                  {faq.answer || "This answer will be updated soon."}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      <Footer />
      <FloatingChatButton />
    </>
  );
};

export default DonationPage;
